import { loadable } from '@tapestry/shared/lazy-load';

const SupplierInsightsModalLazy = loadable(
  () => import('./SupplierInsightsModal'),
  { chunkName: 'supplier-insight-modal' }
);

export { SupplierInsightsModalLazy };
export { SupplierInsightsModal } from './SupplierInsightsModal';
